export default __webpack_public_path__ + "93f845a1d11c9807b6fd2cbb6275c2ba.png";